module.exports = __webpack_public_path__ + "img/3_39.c33b0512.png";